import TagManager from 'react-gtm-module';

// Datalayer Categoria
export function dataLayerButtons(props){
    //console.log('Categoria-DL: ', props)
    const {
        eventName
    } = props

    const tagManagerArgs = {
        dataLayerName: 'PageDataLayer',
        dataLayer: {
            event: eventName
        }
    }
    TagManager.dataLayer(tagManagerArgs)
}

// Datalayer Login
export function dataLayerLogin(){
    //console.log('Login-DL: ', props)

    const tagManagerArgs = {
        dataLayerName: 'PageDataLayer',
        dataLayer: {
            event: 'checkoutStep1',
            ecommerce: {
                checkout: {
                    actionField: {
                        step: 1,
                        option: 'Web'
                    },
                    products: []
                }
            }
        }
    }
    TagManager.dataLayer(tagManagerArgs)
}

// Datalayer Login
export function dataLayerUserLogin(props){
    console.log("use login x1: ", props)  
    const {
        idUser,
        userInfo
    } = props

    
    const tagManagerArgsGA4 = {
        dataLayerName: 'PageDataLayer',
        dataLayer: {
            event: 'login',
            userId: String(idUser),
        }
    }
    
    TagManager.dataLayer(tagManagerArgsGA4)

    const tagManagerArgsGA = {
        dataLayerName: 'PageDataLayer',
        dataLayer: {
            event: 'loginUserid',
            userId: String(idUser)
            //userData: userInfo
            ,userData: window.btoa(userInfo)
        }
    }
    
    TagManager.dataLayer(tagManagerArgsGA)
           
}

export function dataLayerLogout(){
    //console.log('Login-DL: ', props)

    const tagManagerArgs = {
        dataLayerName: 'PageDataLayer',
        dataLayer: {
            event: 'checkoutOption',
            ecommerce: {
                checkout: {
                    actionField: {
                        step: 5,
                        option: 'logout'
                    },
                    products: []
                }
            }
        }
    }
    TagManager.dataLayer(tagManagerArgs)
}

// Datalayer wishlist Agrgar
export function dataLayerWishlistAdd(props){   
    //console.log('WishlistAdd-DL: ', props)
    const {
        item
    } = props

    const tagManagerArgs = {
        dataLayerName: 'PageDataLayer',
        dataLayer: {
            event: 'add_to_wishlist',
            ecommerce: {
                items: item
            }
        }  
    }
    TagManager.dataLayer(tagManagerArgs )
}

// Datalayer Store
export function onPromoClick(id, name, creative, position){

    const tagManagerArgs = {
        dataLayerName: 'PageDataLayer',
        dataLayer: {
            event: 'promotionClick',
            ecommerce: {
                promoClick: {
                    promotions: [
                        {
                            id: id,
                            name: name,
                            creative: creative,
                            position: position
                        }
                    ]
                }
            }
        }
    }
    TagManager.dataLayer(tagManagerArgs)
}